import { formatCents } from "./format";

export const describeShareSummary = (amount, remaining) => {
  if (remaining === 0) {
    return {
      balanced: true,
      text: `Verteilt: ${formatCents(amount)} von ${formatCents(amount)}`,
    };
  }
  return {
    balanced: false,
    text:
      remaining > 0
        ? `Noch offen: ${formatCents(remaining)} von ${formatCents(amount)}`
        : `${formatCents(-remaining)} zu viel verteilt (Gesamt ${formatCents(amount)})`,
  };
};
